import { render, staticRenderFns } from "./studymodule.vue?vue&type=template&id=ddca1b34&"
import script from "./studymodule.vue?vue&type=script&lang=js&"
export * from "./studymodule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports